import { ForgeParticipant } from "@supernova-studio/model";
import { DTOForgeAgent } from "./agent";
import { DTOUser } from "../users";
import { z } from "zod";

export const DTOForgeParticipant = ForgeParticipant.omit({ agent: true, user: true }).extend({
  agent: DTOForgeAgent.optional(),
  user: DTOUser.optional(),
});
export const DTOCreateForgeParticipant = DTOForgeParticipant.omit({
  projectIterationId: true,
  agent: true,
  user: true,
});
export const DTOUpdateForgeParticipant = DTOCreateForgeParticipant.extend({ id: z.string() });

export const DTOCreateForgeParticipantResponse = z.object({
  participant: DTOForgeParticipant,
});

export const DTOUpdateForgeParticipantResponse = z.object({
  participant: DTOForgeParticipant.nullable(),
});

export const DTODeleteForgeParticipantResponse = z.object({
  ok: z.literal(true),
});

export const DTOForgeParticipantsListResponse = z.object({
  participants: z.array(DTOForgeParticipant),
});

export const DTOForgeParticipantGetResponse = z.object({
  participant: DTOForgeParticipant.nullable(),
});

export type DTOForgeParticipantsListResponse = z.infer<typeof DTOForgeParticipantsListResponse>;
export type DTOForgeParticipantGetResponse = z.infer<typeof DTOForgeParticipantGetResponse>;
export type DTOForgeParticipant = z.infer<typeof DTOForgeParticipant>;
export type DTOCreateForgeParticipant = z.infer<typeof DTOCreateForgeParticipant>;
export type DTOUpdateForgeParticipant = z.infer<typeof DTOUpdateForgeParticipant>;
export type DTOCreateForgeParticipantResponse = z.infer<typeof DTOCreateForgeParticipantResponse>;
export type DTOUpdateForgeParticipantResponse = z.infer<typeof DTOUpdateForgeParticipantResponse>;
export type DTODeleteForgeParticipantResponse = z.infer<typeof DTODeleteForgeParticipantResponse>;
